import { useLanguage, useTranslate } from 'context/languageContext';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useLazyGetStaticPageQuery } from 'redux/services/staticPagesService';
import { RUTAS_GENERALES_MUL2 } from 'utils/constants';

export default function UseSEO() {
  const currentLanguage = useLanguage();
  const t = useTranslate();
  const [obtainPage] = useLazyGetStaticPageQuery();
  const navigate = useNavigate();

  async function navigateStaticPage(pageId: number | string, notNavigate?: boolean, parentPath?: string, lang?: string) {
    const curLang = lang ? lang : currentLanguage;
    if (pageId) {
      const result: any = await obtainPage({pageId: pageId, language: curLang});
      let parent = parentPath ? parentPath : '/emt';
      if (result?.data) {
        const codePublic = result?.data?.publicCode;
        !notNavigate && navigate(`/${curLang}${parent}?pageId=${codePublic}`, { state: {pageId: pageId}});
        return codePublic;
      } else {
        !notNavigate && navigate(`/${curLang}${parent}?pageId=${pageId}`, { state: { pageId: pageId }});
      }
    }
    return null;
  }

  const slugParams = (param: string): string => {
    if (!param) return 'line';
    return param
      .toLowerCase()
      .trim()
      .replace(/['|/]/g, '') // Elimina ' | /
      .replace(/[\s]+/g, '-') // Reemplaza espacios por '-'
      .replace(/[-]+/g, '_'); // Reemplaza guiones múltiples por '_'
  };

  const generateUrl = (destiny, type?: string, info?: any): string => {
    if (type && (type.toUpperCase() === 'STOP' || type.toUpperCase() === 'POI'))
      return (
        '/' +
        currentLanguage +
        '/' +
        destiny[currentLanguage] +
        (info?.code || info?.id) +
        '/' +
        slugParams(info?.name)
      );
    if (type && type.toUpperCase() === 'LINEA')
      return (
        '/' +
        currentLanguage +
        '/' +
        destiny[currentLanguage] +
        info?.linea?.code +
        '/' +
        slugParams(info?.linea?.name) +
        '/' +
        info?.direccion?.tripId +
        '/' +
        slugParams(info?.direccion?.headSign || info?.direccion?.label) +
        '/' +
        info?.direccion?.directionId +
        '/' +
        info?.direccion?.subLineId
      );
    if (type && type.toUpperCase() === 'ADVICE') {
      return (
        '/' +
        currentLanguage +
        '/' +
        destiny[currentLanguage] +
        info
      );
    }
    if (type && type.toUpperCase() === 'EVENT') {
      return (
        '/' +
        currentLanguage +
        '/' +
        destiny[currentLanguage] +
        info?.event?.id +
        '/' +
        slugParams(info?.event?.name)
      );
    }
    if (type && type.toUpperCase() === 'PLAN') {
      if (info?.length > 0) {
        if (info?.length === 1) {
          return (
            '/' +
            currentLanguage +
            '/' +
            destiny[currentLanguage] +
            (info[0]?.code || info[0]?.id) +
            '/' +
            slugParams(info[0]?.name)
          );
        } else {
          return (
            '/' +
            currentLanguage +
            '/' +
            destiny[currentLanguage] +
            (info[0]?.code || info[0]?.id) +
            '/' +
            slugParams(info[0]?.name) +
            '/' +
            (info[1]?.code || info[1]?.id) +
            '/' +
            slugParams(info[1]?.name)
          );
        }
      }
    }
    if (type === 'SUB' || destiny === RUTAS_GENERALES_MUL2.any)
      return `/${currentLanguage}${destiny}`;
    if (destiny === RUTAS_GENERALES_MUL2.main || destiny === RUTAS_GENERALES_MUL2.any) return '/';
    return '/' + currentLanguage + '/' + destiny[currentLanguage];
  };

  const generateTitleAndMeta = (title: string, description?: string | null) => {
    return (
      <Helmet prioritizeSeoTags>
        <title>{title ?? ''} - EMT Palma</title>
        <meta name='description' content={description ?? t('lb_seo_default_description')} />
      </Helmet>
    );
  };

  return [generateUrl, generateTitleAndMeta, navigateStaticPage] as const;
}
